import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';
import { route } from 'preact-router';
import linkstate from 'linkstate';
import md5 from 'crypto-js/md5';

import fields from '../../lib/fields';

import FormFields from '../../components/form/fields';
import ImageScroller from '../../components/imagescroller';
import HelpText from '../../components/gui/helpText';
import Input from '../../components/form/input';
import GuiList from '../../components/gui/list';
import UserProfileInline from '../../components/user/profileInline';
import Camera from '../../components/gui/camera';

import localUtil from '../../lib/util';
import { QRCodeSVG } from 'qrcode.react';

class ConventionViewSponsors extends Component {
  	constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { isStarted } = this.props;
        const { appState, userStore, conventionStore, conventionResultStore } = this.props.stores;
        const { mainView, subView, isDevelopment, path } = appState;
        const { user = {}, isAdmin, isCustomerAdmin, isTester, isVeterinary, language, searchUsersResult } = userStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        const { convention, jwtToken, otp = '' } = conventionStore;

        return (<>
            {convention.sponsors && convention.sponsors.length > 0 && <>
                <div class={`d-flex flex-row justify-content-between align-items-center mt-3 mx-3 px-3 py-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}>
                    <div class='d-flex flex-row flex-wrap align-items-center justify-content-center w-100'>
                        {convention.sponsors.map((sponsor, idx) => {
                            const meta = convention.sponsorsMeta ? convention.sponsorsMeta[idx] : {};
                            const imgSrc = `${sponsor.s3LargeLink}`;
                            return (<>
                                <div class='my-3 mx-5'>
                                    <a href={meta?.url} target='_blank' rel='noopener noreferrer' title={meta?.name}>
                                        <img
                                            class='img-fluid'
                                            style={`max-height: 100px; max-width: 300px`}
                                            src={imgSrc}
                                            alt={sponsor.name}
                                        />
                                    </a>
                                </div>
                            </>);
                        })}
                    </div>
                </div>
            </>}
        </>);
    }
}
export default ConventionViewSponsors;
